// Book-row comic hover — modal kind. Bookshelf-style row of books on a
// shelf; hovering one outlines its spine + makes it E-eligible. When the
// book-browse state has a non-default index, the browse-index entry wins
// over the hover entry for the E target (legacy behaviour from the E
// handler's `bookBrowseIndex >= 0 ? this.bookEntries[…] : this.hoveredBook`).

import { registerInteractable } from "../_interactable-registry.js";
import { addOutline, removeOutline } from "../helpers.js";

registerInteractable({
	id: "book-row",
	precedence: 75,
	// ASK-137 §84 — THIS KIND'S OWN PROMPT AND SUBJECT. `stage.js` used to enumerate every kind by
	// hand, twice (`_updateEHint`'s hover ladder and `_hoveredProduct`), which is exactly what the
	// registry's own header says a registry exists to end. The prompt a shopper reads and the product
	// it names belong where the rest of this kind's behaviour already is.
	hoverHint: '<kbd>E</kbd> Pick Up',
	productOf(stage, active) {
		// Browse-index wins over hover for the SUBJECT, exactly as `interactE` does — the thing the
		// press will take is the thing the hint should name.
		const byIdx = stage.bookBrowseIndex >= 0 ? stage.bookEntries?.[stage.bookBrowseIndex] : null;
		return (byIdx || active)?.product ?? null;
	},

	suppressedBy(stage) {
		if (stage.boxState === "open" || stage.boxState === "browsing" || stage.boxState === "hero") return true;
		if (stage.activeFixtureHero) return true;
		if (stage.activeVinylBin)    return true;
		if (stage.activeStackTable)  return true;
		if (!stage.bookEntries?.length) return true;
		return false;
	},

	// ASK-139 F-139af — a book is its catalogue GLB: a ROOT over several meshes (cover · spine · pages),
	// so the ray is cast into the subtree and walked back up to the entry that owns the hit. The
	// dispatcher's default (`intersectObjects(targets, false)`) only ever matched a single-mesh book.
	evaluateActive(stage) {
		const entries = stage.bookEntries;
		if (!entries?.length) return null;
		const hits = stage.raycaster.intersectObjects(entries.map((b) => b.mesh), true);
		for (const h of hits) {
			for (let n = h.object; n; n = n.parent) {
				const e = entries.find((b) => b.mesh === n);
				if (e) return e;
			}
		}
		return null;
	},

	commitHover(stage, prev, next) {
		if (prev?.mesh && prev !== next) removeOutline(prev.mesh);
		stage.hoveredBook = next;
		if (next?.mesh && prev !== next) addOutline(next.mesh);
	},

	interactE(stage) {
		// Browse-index wins over hover (matches legacy E handler).
		const target = stage.bookBrowseIndex >= 0
			? stage.bookEntries[stage.bookBrowseIndex]
			: stage.hoveredBook;
		if (!target) return false;
		stage.setBookHero(target);
		return true;
	},
});
